import { Link } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import {
  PenTool, Sparkles, Palette, Package, CreditCard, Megaphone, Search, LifeBuoy, Globe, BarChart3, Languages, Smartphone,
} from "lucide-react";

const features = [
  { icon: PenTool, title: "Création manuelle", text: "Construisez votre boutique vous-même, étape par étape, avec un essai gratuit de 14 jours sans carte bancaire." },
  { icon: Sparkles, title: "Boutique IA", text: "Choisissez une niche : notre IA génère votre catalogue, vos descriptions, vos images et vos pages essentielles (offre payante)." },
  { icon: Palette, title: "Thèmes", text: "Des thèmes modernes et personnalisables : logo, couleurs, polices et sections de page d'accueil." },
  { icon: Package, title: "Catalogue produits", text: "Photos, variantes, prix, stock et catégories. Import de produits en masse et migration depuis d'autres plateformes." },
  { icon: CreditCard, title: "Paiements", text: "Encaissez vos ventes en toute sécurité avec Stripe et PayPal, avec des identifiants propres à votre boutique." },
  { icon: Megaphone, title: "Marketing", text: "Codes de réduction, e-mails marketing, relance des paniers abandonnés, programme de fidélité et vidéos promotionnelles." },
  { icon: Search, title: "SEO", text: "Titres et descriptions optimisés, adresses de pages lisibles, plan de site et données structurées automatiques." },
  { icon: Globe, title: "Nom de domaine", text: "Sous-domaine sokoby.com offert, achat de domaine intégré ou connexion d'un domaine existant." },
  { icon: Languages, title: "Multilingue", text: "Proposez votre boutique dans plusieurs langues, y compris l'arabe avec mise en page de droite à gauche." },
  { icon: BarChart3, title: "Statistiques", text: "Suivez vos ventes, vos commandes et le comportement de vos visiteurs depuis votre tableau de bord." },
  { icon: Smartphone, title: "Adapté au mobile", text: "Votre boutique s'affiche parfaitement sur téléphone, tablette et ordinateur." },
  { icon: LifeBuoy, title: "Support", text: "Une équipe disponible par e-mail, des guides pas à pas et un centre d'aide en français." },
];

export default function Features() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1">
        <section className="container mx-auto px-4 py-20 md:py-28 text-center max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Nos fonctionnalités</h1>
          <p className="text-lg text-muted-foreground">
            Tout ce qu'il faut pour créer, gérer et développer votre boutique en ligne — à la main ou avec l'IA.
          </p>
        </section>

        <section className="container mx-auto px-4 pb-20 md:pb-28">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map(({ icon: Icon, title, text }) => (
              <div key={title} className="rounded-2xl border bg-card p-8 transition-all hover:-translate-y-1 hover:shadow-lg">
                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                  <Icon className="h-6 w-6 text-primary" />
                </div>
                <h2 className="text-xl font-semibold mb-3">{title}</h2>
                <p className="text-muted-foreground leading-relaxed">{text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-muted/50 py-20 md:py-28">
          <div className="container mx-auto px-4 text-center max-w-2xl">
            <h2 className="text-3xl font-bold mb-4">Prêt à lancer votre boutique ?</h2>
            <p className="text-muted-foreground mb-8">
              Essai gratuit de 14 jours avec la création manuelle, sans carte bancaire. Ou laissez l'IA créer votre boutique.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg"><Link to="/inscription">Commencer l'essai gratuit</Link></Button>
              <Button asChild size="lg" variant="outline"><Link to="/creer-boutique-ia">Boutique IA</Link></Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
